<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j48jFk/tc-custom/9781609252229.jpg?1728851724905" alt="This image is the cover for the book Community of Kindness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Community of Kindness
      </h1>
      <p class="bookDescription body article font2">
        <b>“An eloquent reminder of the great truth that life is with people and none of us can be truly human alone.” —Harold S. Kushner, author of <i>When Bad Things Happen to Good People</i></b><br/><br/>The world has changed in so many ways in recent decades—and as a result, meaningful connections are increasingly elusive. <i>The</i><i>Community of Kindness</i> encourages us to create new ways of building community through the practice of kindness. It is through that effort that we become most fully connected, alive, and integrated.<br/><br/>From the people who brought us <i>Random Acts of Kindness</i>, this insightful book can not only lift your heart, but fill it with the happiness that comes from feeling a sense of connection with the world and people around us.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Editors of Random Acts of Kindness
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Conari Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13708d77